module.exports = __webpack_public_path__ + "img/P150T_weapon_124.519ca5d7.png";